import { h } from '@stencil/core';
import { SVGOpts } from '../../../common/images/icons-opts';

export const IconOutOfStock = (opts?: SVGOpts) => (
  <svg
    class={opts?.class}
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.28516 6.25L10.9062 2.66406L11.6445 1.92578C11.75 1.82031 11.75 1.64453 11.6445 1.50391L10.8711 0.730469C10.7305 0.625 10.5547 0.625 10.4492 0.730469L6.125 5.08984L1.76562 0.730469C1.66016 0.625 1.48438 0.625 1.34375 0.730469L0.570312 1.50391C0.464844 1.64453 0.464844 1.82031 0.570312 1.92578L4.92969 6.25L0.570312 10.6094C0.464844 10.7148 0.464844 10.8906 0.570312 11.0312L1.34375 11.8047C1.48438 11.9102 1.66016 11.9102 1.76562 11.8047L6.125 7.44531L9.71094 11.0664L10.4492 11.8047C10.5547 11.9102 10.7305 11.9102 10.8711 11.8047L11.6445 11.0312C11.75 10.8906 11.75 10.7148 11.6445 10.6094L7.28516 6.25Z"
      fill="#CF364E"
    />
  </svg>
);
